import styled from "styled-components";

export const CategoryLeadersPageWrapper = styled.div`
    width: 100%;
`;
